/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Open_User_MenuInputs */

const en_nav_open_user_menu = /** @type {(inputs: Nav_Open_User_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open user menu`)
};

const fr_nav_open_user_menu = /** @type {(inputs: Nav_Open_User_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir le menu utilisateur`)
};

/**
* | output |
* | --- |
* | "Open user menu" |
*
* @param {Nav_Open_User_MenuInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const nav_open_user_menu = /** @type {((inputs?: Nav_Open_User_MenuInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Open_User_MenuInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_open_user_menu(inputs)
	return fr_nav_open_user_menu(inputs)
});